<template>
   <div class="content-wrapper">
     <section class="content-header">
       <div class="row">
         <div class="col-xs-6">
           <h1>{{ isEditMode ? 'Edit Coupon' : 'Add New Coupon' }}</h1>
         </div>
         <div class="col-xs-6 mandatoryDiv">
           <span class="mandatory_color">(*)</span> <span class="letter-right"> Marked are required field</span>
         </div>
       </div>
     </section>
     <section class="content">
       <div class="row">
         <div class="col-sm-12">
           <div class="alert alert-info" v-if="alert_message">
             {{alert_message}}
           </div>
         </div>
         <form role="form" id="formID">
           <div class="col-sm-6">
             <div class="box">
               <div class="box-header">
                 <h3 class="box-title">
                   Coupon Information                            
                 </h3>
               </div>
               <div class="box-body form-box-body form-horizontal">
                 <div class="form-group">
                   <label class="col-md-4 control-label">Coupon Code <span class="mandatory_horizontal">*</span></label>
                   <div class="col-md-8">
                     <input name="code" id="code" v-model="coupon_code" class="form-control input-sm" placeholder="COUPON123" type="text">
                     <label v-if="error_code" class="error" for="code">{{error_code}}</label>
                   </div>
                 </div>
                <div class="form-group">
  <label class="col-md-4 control-label">Validity From <span class="mandatory_horizontal">*</span></label>
  <div class="col-md-8">
    <input 
      type="date" 
      class="form-control input-sm" 
      v-model="start_date" 
      id="start_date"
      :min="new Date().toISOString().split('T')[0]"
    >
    <label v-if="error_start_date" class="error">{{error_start_date}}</label>
  </div>
</div>
<div class="form-group">
  <label class="col-md-4 control-label">Validity To <span class="mandatory_horizontal">*</span></label>
  <div class="col-md-8">
    <input 
      type="date" 
      class="form-control input-sm" 
      v-model="end_date" 
      id="end_date"
      :min="start_date || new Date().toISOString().split('T')[0]"
    >
    <label v-if="error_end_date" class="error">{{error_end_date}}</label>
  </div>
</div>
                 <div class="form-group">
                  <label class="col-md-4 control-label">Usage Type <span class="mandatory_horizontal">*</span></label>
                  <div class="col-md-8">
                    <select class="form-control input-sm" v-model="usage_type" id="usage_type">
                      <option value="one_time">One-time use</option>
                      <option value="recurring">Recurring (multiple uses)</option>
                    </select>
                    <label v-if="error_usage_type" class="error" for="usage_type">{{error_usage_type}}</label>
                  </div>
                </div>
                <div class="form-group">
                   <label class="col-md-4 control-label">Maximum Uses <span class="mandatory_horizontal">*</span></label>
                   <div class="col-md-8">
                     <input type="number" class="form-control input-sm" v-model="max_uses" id="max_uses" min="1" placeholder="Maximum number of times this coupon can be used">
                     <label v-if="error_max_uses" class="error" for="max_uses">{{error_max_uses}}</label>
                   </div>
                 </div>
                 
                <div class="form-group">
                  <label class="col-md-4 control-label">Discount Type <span class="mandatory_horizontal">*</span></label>
                  <div class="col-md-8">
                    <select class="form-control input-sm" v-model="discount_type" id="discount_type">
                      <option value="">Select Type</option>
                      <option value="fixed">Fixed Amount</option>
                      <option value="percentage">Percentage</option>
                    </select>
                    <label v-if="error_discount_type" class="error" for="discount_type">{{error_discount_type}}</label>
                  </div>
                </div>
                 <div class="form-group">
                   <label class="col-md-4 control-label">Discount Value <span class="mandatory_horizontal">*</span></label>
                   <div class="col-md-8">
                     <input type="number" class="form-control input-sm" v-model="discount_value" id="discount_value">
                     <label v-if="error_discount_value" class="error" for="discount_value">{{error_discount_value}}</label>
                   </div>
                 </div>
                 <div class="form-group">
                   <label class="col-md-4 control-label">Stripe Coupon ID <span class="mandatory_horizontal">*</span></label>
                   <div class="col-md-8">
                     <select class="form-control input-sm" v-model="stripe_coupon_id" id="stripe_coupon_id">
                       <option value="">Select Stripe Coupon</option>
                       <option v-for="coupon in stripe_coupons" :key="coupon.id" :value="coupon.id">{{ coupon.name }}</option>
                     </select>
                     <label v-if="error_stripe_coupon_id" class="error" for="stripe_coupon_id">{{error_stripe_coupon_id}}</label>
                   </div>
                 </div>  

             <!-- Shown only if usage_type is recurring -->
<div class="form-group">
  <label class="col-md-4 control-label">Create New Paypal Plan</label>
  <div class="col-md-8">
    <input 
      type="checkbox" 
      v-model="create_new_plan" 
      id="create_new_plan"
      :disabled="!isEditMode && usage_type !== 'recurring'"
    >
  </div>
</div>

<div class="form-group" >
  <label class="col-md-4 control-label">Paypal Plan Name Prefix</label>
  <div class="col-md-8">
    <input
      type="text"
      class="form-control input-sm"
      v-model="plan_name_prefix"
      placeholder="Plan name prefix will auto-fill from coupon code"
      :readonly="!create_new_plan"
      :class="{'bg-light': !create_new_plan}"
    >
     <small v-if="!create_new_plan" class="text-muted">
      {{ isEditMode ? 'Using existing plan prefix' : 'Prefix will be generated' }}
    </small>
  </div>
</div>

<div class="form-group" v-if="isEditMode && paypal_plan_id">
  <label class="col-md-4 control-label">Existing Paypal Plan ID</label>
  <div class="col-md-8">
    <input
      type="text"
      class="form-control input-sm"
      :value="paypal_plan_id"
      readonly
    >
  </div>
</div>
                <div class="form-group">
                        <label class="col-md-4 control-label">Active</label>
                        <div class="col-md-8">
                           <input name="status" type="checkbox" id="status" value="1" checked="checked" v-model="status">
                        </div>
                    </div>
               </div>
             </div>
             <div class="col-sm-12 btnRight">
               <input type="submit" name="submit" :value="isEditMode ? 'Update' : 'Submit'" class="btn btn-sm btn-submit btn-submit-big" @click="formSubmit">
              
             </div>
           </div>
         </form>
       </div>
     </section>
   </div>
 </template>
 
 <script>
 import axios from 'axios'
 export default {
   name: "AddCoupon",
   props: {
     id: {
       type: String,
       default: null
     }
   },
  data() {
  return {
    coupon_code: '',
    start_date: '',
    end_date: '',
    usage_type: '',
    max_uses: '',
    discount_type: '',
    discount_value: '',
   status : true,
    stripe_coupon_id: '',
    stripe_coupons: [],
    create_new_plan: false,
    plan_name_prefix: '',
    paypal_plan_id: '', 

    // error flags
    error_code: false,
    error_start_date: '',  
    error_end_date: '',
    error_usage_type: false,
    error_max_uses: false,
    error_discount_type: false,
    error_discount_value: false,
    alert_message: '',
    error_stripe_coupon_id: false
  }
},

   computed: {
     isEditMode() {
       return this.id !== null
     }
   },
   created() {
     if (this.isEditMode) {
       this.fetchCoupon()
     }
     this.fetchStripeCoupons();
   },
watch: {
  coupon_code(newVal) {
    if (this.usage_type === 'recurring' && this.create_new_plan) {
      this.plan_name_prefix = newVal;
    }
  },
  usage_type(newVal) {
    if (newVal === 'recurring') {
      this.create_new_plan = true; // Default to creating new plan
      this.plan_name_prefix = this.coupon_code;
    } else {
      this.plan_name_prefix = '';
      this.create_new_plan = false;
    }
  },
  create_new_plan(newVal) {
    if (newVal && this.usage_type === 'recurring') {
      // When enabling new plan, auto-fill with coupon code
      this.plan_name_prefix = this.coupon_code;
    }
  }
},

   methods: {
 formatDateForInput(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  },
  
  formatDateForServer(dateString) {
    if (!dateString) return '';
    return dateString + ' 00:00:00';
  },

     fetchCoupon() {
       axios.get(`coupons/${this.id}`)
      
         .then(response => {
           console.log("response");
           const coupon = response.data
           this.coupon_code = coupon.coupon_code
           this.start_date = coupon.start_date ? coupon.start_date.split(' ')[0] : '';
          this.end_date = coupon.end_date ? coupon.end_date.split(' ')[0] : '';
           this.usage_type = coupon.usage_type
           this.max_uses = coupon.max_uses
           this.discount_type = coupon.discount_type
          this.discount_value = coupon.discount_value
              this.status = coupon.status === "active" || coupon.status === 1;
             this.stripe_coupon_id=coupon.stripe_coupon_id
            this.create_new_plan = coupon.create_new_plan || false;
      this.plan_name_prefix = coupon.plan_name_prefix || this.coupon_code;
      this.paypal_plan_id = coupon.paypal_plan_id || '';

      if (this.isEditMode && !this.create_new_plan && coupon.plan_name_prefix) {
        this.plan_name_prefix = coupon.plan_name_prefix;
      }
         })
         .catch(error => {
           console.error('Error fetching coupon:', error)
         })
     },

     
     formSubmit(e) {
       e.preventDefault();
       const rootObject = this;
       
       // Validate form
       var result = this.formValidation();
       if (result) {
         return 0;
       }
       if (this.status===true) {
               var status = 1;
            }else{
               var status = 2;
            } 
       loader.show();
       const form = new FormData()
       form.append('coupon_code', this.coupon_code)
       if(this.description){
         form.append('description', this.description)
       }
       form.append('start_date', this.start_date + ' 00:00:00');
       form.append('end_date', this.end_date + ' 23:59:59');
       form.append('usage_type', this.usage_type)
       form.append('max_uses', this.max_uses)
        form.append('discount_type', this.discount_type)
       form.append('discount_value', this.discount_value)
      form.append('status', this.status ? 'active' : 'inactive') // Convert boolean to string 'active' or 'inactive'
      form.append('stripe_coupon_id', this.stripe_coupon_id);
if (this.usage_type === 'recurring') {
    form.append('create_new_plan', this.create_new_plan ? '1' : '0');
    form.append('plan_name_prefix', this.plan_name_prefix);
    if (this.paypal_plan_id) {
      form.append('paypal_plan_id', this.paypal_plan_id);
    }
  }
       var config = {
         headers: { 'Content-Type': 'multipart/form-data' }
       }
 let request; // Add this line before the if block

if (this.isEditMode) {
  form.append('_method', 'PUT'); // Method spoofing
  request = axios.post(`coupons/${this.id}`, form, config)
} else {
  request = axios.post('coupons', form, config)
}



 
       request.then(function (response) {
        rootObject.alert_message = `Coupon Successfully`;
         loader.hide();
         rootObject.$router.push({ name: 'CouponList' });
          rootObject.$router.push({
        name: 'CouponList',
           query: { success: true, action: 'added' } // Pass success message via query params
      
        });
     })
       .catch(function (error) {
          let alertmessage = "";

          if (error.response && error.response.data && error.response.data.message) {
            const messages = error.response.data.message;
            for (let key in messages) {
              alertmessage += `${key}: ${messages[key].join(', ')}\n`;
            }
          } else {
            alertmessage = "An unknown error occurred.";
          }

         console.log(alertmessage);
         loader.hide();
         rootObject.alert_message = alertmessage;
       });
 
       setTimeout(function(){  
         rootObject.alert_message = '';
       }, 5000);
     },
 
     formValidation() {
       let has_error = false;
       
       // Reset errors
       this.error_code = false;
       this.error_start_date = '';  
       this.error_end_date = ''; 
       this.error_discount_type = false;
       this.error_discount_value = false;
       this.error_stripe_coupon_id = false;

       // Validate coupon code
       if(!this.coupon_code) { 
         this.error_code = "Coupon code is required";
         has_error = true;
       }
 
       // Validate stripe coupon id
       if(!this.stripe_coupon_id) {
         this.error_stripe_coupon_id = "Stripe Coupon ID is required";
         has_error = true;
       }

      const today = new Date().toISOString().split('T')[0];
  
        if (!this.start_date) {
          this.error_start_date = "Start date is required";
          has_error = true;
        } else if (this.start_date < today) {
          this.error_start_date = "Start date cannot be in the past";
          has_error = true;
        }
        
        if (!this.end_date) {
          this.error_end_date = "End date is required";
          has_error = true;
        } else if (this.start_date && this.end_date < this.start_date) {
          this.error_end_date = "End date must be after start date";
          has_error = true;
        }

 
       // Validate discount type
       if(!this.discount_type) {
         this.error_discount_type = "Discount type is required";
         has_error = true;
       }
 
       // Validate discount value
       if(!this.discount_value) {
         this.error_discount_value = "Discount value is required";
         has_error = true;
       } else if (this.discount_type === 'percentage' && (this.discount_value <= 0 || this.discount_value > 100)) {
         this.error_discount_value = "Percentage must be between 1 and 100";
         has_error = true;
       } else if (this.discount_type === 'fixed' && this.discount_value <= 0) {
         this.error_discount_value = "Amount must be greater than 0";
         has_error = true;
       }
 
       return has_error;
     },
     fetchStripeCoupons() {
       axios.get(`https://api.v1.dev.entervpn.com/vpnadmin/stripe-coupons`)
         .then(response => {
           this.stripe_coupons = response.data.data;
         })
         .catch(error => {
           console.error('Error fetching Stripe coupons:', error);
           this.alert_message = "Failed to load Stripe coupons.";
         });
     }
   },
 };
 </script>
 
 <style scoped>
 /* .error {
   color: #ff0000;
   font-size: 12px;
 }
 .mandatory_horizontal {
   color: #ff0000;
 } */
 </style>